import React, { useEffect, useRef, useState } from 'react';
import * as styles from './AWLogistics.module.css';
import * as generalStyles from './AWGeneral.module.css';
import { useLanguage } from '../../../i18n';
import { MarketModal } from '../../../components/Modals/MarketModal';

// ... (Data arrays omitted for brevity, keeping them as is)
// Extended catalog items (Fruits)
const FRUIT_DATA = [
    { id: 1, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/fr_001_aw.png" },
    { id: 2, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/fr_002_aw.png" },
    { id: 3, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/fr_003_aw.png" },
    { id: 4, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/fr_004_aw.png" },
    { id: 5, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/fr_005_aw.png" },
    { id: 6, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/fr_006_aw.png" },
    { id: 7, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/fr_007_aw.png" },
    { id: 8, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/fr_008_aw.png" },
    { id: 9, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/fr_009_aw.png" },
    { id: 10, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/fr_010_aw.png" },
    { id: 11, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/fr_011_aw.png" },
    { id: 12, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/fr_012_aw.png" },
    { id: 13, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/fr_013_aw.png" },
    { id: 14, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/fr_014_aw.png" },
    { id: 15, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/fr_015_aw.png" },
    { id: 16, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/fr_016_aw.png" }
];

// Veggie items
const VEGGIE_DATA = [
    { id: 101, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/vg_001_aw.png" },
    { id: 102, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/vg_002_aw.png" },
    { id: 103, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/vg_003_aw.png" },
    { id: 104, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/vg_004_aw.png" },
    { id: 105, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/vg_005_aw.png" },
    { id: 106, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/vg_006_aw.png" },
    { id: 107, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/vg_007_aw.png" },
    { id: 108, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/vg_008_aw.png" },
    { id: 109, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/vg_009_aw.png" }
];

const GRAINS_DATA = [
    { id: 201, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/sn_001_aw.png" }, // Cafe
    { id: 202, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/sn_002_aw.png" }, // Caraota
    { id: 203, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/sn_003_aw.png" }, // Lentejas
    { id: 204, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/sn_004_aw.png" }, // Alubias
    { id: 205, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/sn_005_aw.png" }, // Quinoa
    { id: 207, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/sn_007_aw.png" }  // Avena
];

const PROTEIN_DATA = [
    { id: 301, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/pr_001_aw.png" }, // Salmon
    { id: 302, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/pr_002_aw.png" }, // Cerdo
    { id: 303, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/pr_003_aw.png" }, // Pollo
    { id: 304, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/pr_004_aw.png" }, // Res
    { id: 305, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/pr_005_aw.png" }, // Atun
    { id: 306, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/pr_006_aw.png" }, // Camarones
    { id: 307, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/pr_007_aw.png" }, // Pulpo
    { id: 308, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/pr_008_aw.png" }  // Pescado
];

const HAM_DATA = [
    { id: 401, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/mt_001_aw.png" }, // Salami
    { id: 402, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/mt_002_aw.png" }, // Tocineta
    { id: 403, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/mt_003_aw.png" }, // Jamon Pavo
    { id: 404, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/mt_004_aw.png" }, // Salchicha
    { id: 405, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/mt_005_aw.png" }, // Jamon Ahumado
    { id: 406, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/mt_006_aw.png" }  // Jamon Iberico
];

const DAIRY_DATA = [
    { id: 501, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/ch_001_aw.png" }, // Queso Amarillo (001)
    { id: 502, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/ch_002_aw.png" }, // Queso Blanco (002)
    { id: 503, smoke: "/assets/backgounds/smk_003_aw_catalog.png", fruit: "/assets/backgounds/ch_003_aw.png" }, // Queso Azul/Gruyere (003)
    { id: 504, smoke: "/assets/backgounds/smk_004_aw_catalog.png", fruit: "/assets/backgounds/ch_004_aw.png" }, // Huevos (004)
    { id: 505, smoke: "/assets/backgounds/smk_005_aw_catalog.png", fruit: "/assets/backgounds/ch_005_aw.png" }, // Huevos Codorniz (005)
    { id: 506, smoke: "/assets/backgounds/smk_001_aw_catalog.png", fruit: "/assets/backgounds/ch_006_aw.png" }, // Mantequilla (006)
    { id: 507, smoke: "/assets/backgounds/smk_002_aw_catalog.png", fruit: "/assets/backgounds/ch_007_aw.png" }  // Queso Crema (007)
];

interface SectionProps {
    data: typeof FRUIT_DATA;
    title: string;
    reversed?: boolean;
    namespaceKey: string;
    keepIndices?: number[];
    id?: string;
}

const LogisticsSection: React.FC<SectionProps> = ({ data, title, reversed = false, namespaceKey, keepIndices, id }) => {
    const { t } = useLanguage();
    const containerRef = useRef<HTMLDivElement>(null);
    const [docked, setDocked] = useState(false);
    const [sliderActive, setSliderActive] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progressFill, setProgressFill] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isInView, setIsInView] = useState(false);

    const items = data.map((item, index) => {
        const i = index + 1;
        return {
            ...item,
            title: t.catalog?.[`${namespaceKey}${i}_title`] || '',
            subtitle: t.catalog?.[`${namespaceKey}${i}_subtitle`] || '',
            desc: t.catalog?.[`${namespaceKey}${i}_desc`] || ''
        };
    });

    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();

            const windowHeight = window.innerHeight;
            // Check visibility with a small buffer for smooth re-entry
            const visible = rect.top < windowHeight + 100 && rect.bottom > -100;
            setIsInView(visible);

            const elementHeight = rect.height;
            const scrollableDistance = elementHeight - windowHeight;
            let p = -rect.top / scrollableDistance;
            p = Math.max(0, Math.min(1, p));
            setScrollProgress(p);

            const triggerOffset = -window.innerHeight * 0.3;

            // Logic for entering/leaving the active sliding zone
            // We adding a check for rect.bottom to stop it when scrolled past
            if (visible && rect.top <= triggerOffset && rect.bottom > windowHeight * 0.5) {
                if (!docked && !sliderActive) {
                    setDocked(true);
                    setTimeout(() => {
                        setSliderActive(true);
                    }, 1000);
                }
            } else {
                // Undock/Stop slider if we go back up OR scroll past down
                if ((rect.top > triggerOffset + 100) || (rect.bottom <= windowHeight * 0.5)) {
                    setDocked(false);
                    setSliderActive(false);
                    setCurrentIndex(0);
                }
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        // Run once on mount
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [docked, sliderActive]);

    useEffect(() => {
        if (!sliderActive || !isInView) return; // Stop timer if not in view

        const intervalDuration = 3000;
        const frameRate = 30;
        let startTime = Date.now();

        const timer = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const p = Math.min(100, (elapsed / intervalDuration) * 100);
            setProgressFill(p);

            if (elapsed >= intervalDuration) {
                setCurrentIndex((prev) => (prev + 1) % items.length);
                startTime = Date.now();
                setProgressFill(0);
            }
        }, frameRate);

        return () => clearInterval(timer);
    }, [sliderActive, isInView, items.length]);

    const currentItem = items[currentIndex];

    // Fade out logic: starts at 90% scroll completion, fully transparent at 100%
    const sectionOpacity = scrollProgress > 0.9 ? 1 - (scrollProgress - 0.9) * 10 : 1;

    return (
        <div className={styles.container} ref={containerRef} id={id}>
            {!isInView ? (
                // Lightweight placeholder when out of view to keep scroll height correct
                <div style={{ width: '100%', height: '100%' }} />
            ) : (
                <div
                    className={`${styles.stickyWrapper} ${reversed ? styles.reversed : ''}`}
                    style={{ opacity: sectionOpacity }}
                >
                    {/* Scroll Line (Global per section) */}
                    <div className={`${generalStyles.scrollProgressLine} ${generalStyles.light}`}>
                        <div className={generalStyles.scrollProgressLabel}>{title}</div>
                        <div
                            className={generalStyles.scrollProgressIndicator}
                            style={{ top: `${scrollProgress * 100}%` }}
                        />
                    </div>

                    <div className={styles.leftPanel}>
                        {/* Images: Smoke + Product */}
                        {/* NOTE: If reversed, CSS row-reverse puts this visually on RIGHT. Content is same. */}
                        {items.map((item, idx) => (
                            <div
                                key={`smoke-${item.id}`}
                                className={`${styles.smokeLayer} ${idx === currentIndex && sliderActive ? styles.activeImage : ''}`}
                                style={{ backgroundImage: `url('${item.smoke}')` }}
                            />
                        ))}
                        {items.map((item, idx) => (
                            <img
                                key={`prod-${item.id}`}
                                src={item.fruit}
                                alt={item.title}
                                className={`${styles.fruitImageLayer} ${idx === currentIndex && sliderActive ? styles.activeImage : ''}`}
                            />
                        ))}
                    </div>

                    <div className={`${styles.fruitTextWrapper} ${docked ? styles.docked : ''}`}>
                        <div className={styles.fruitWord}>
                            {title.split('').map((letter, i) => {
                                const isKept = !keepIndices || keepIndices.includes(i);
                                return (
                                    <span
                                        key={i}
                                        className={!isKept ? styles.dimmed : ''}
                                    >
                                        {letter}
                                    </span>
                                );
                            })}
                        </div>
                    </div>

                    <div className={styles.rightPanel}>
                        {/* INFO Panel */}
                        <div className={`${styles.productInfo} ${sliderActive ? styles.visible : ''}`}>
                            <div className={styles.productTitleRow}>
                                <h2 className={styles.productTitle}>{currentItem.title}</h2>
                                <div className={styles.titleLine} />
                            </div>
                            <div className={styles.productSubtitle}>{currentItem.subtitle}</div>
                            <p className={styles.productDesc}>{currentItem.desc}</p>
                            <div className={styles.bottomControls}>
                                <div className={styles.stars}>
                                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                                </div>
                                <div className={styles.actionRow}>
                                    <button className={styles.btnCatalog} onClick={() => setIsModalOpen(true)}>Catálogo</button>
                                    <button className={styles.btnSquare} onClick={() => setIsModalOpen(true)}>
                                        <img
                                            src="/assets/icons/general_icons/details_icon_onboarding.svg"
                                            alt="Details"
                                            className={styles.btnIcon}
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {sliderActive && (
                        <div className={styles.progressContainer}>
                            {[
                                (currentIndex - 1 + items.length) % items.length,
                                currentIndex,
                                (currentIndex + 1) % items.length
                            ].map((realIdx, position) => (
                                <div
                                    key={realIdx}
                                    onClick={() => {
                                        setCurrentIndex(realIdx);
                                        setProgressFill(0);
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    style={{ padding: '10px 0', cursor: 'pointer' }}
                                >
                                    <div className={styles.progressDot}>
                                        <div
                                            className={styles.progressFill}
                                            style={{
                                                width: position === 0 ? '100%' : (position === 1 ? `${progressFill}%` : '0%')
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            )}
            {isModalOpen && <MarketModal onClose={() => setIsModalOpen(false)} redirectOnClose={false} />}
        </div>
    );
};

export const AWLogistics: React.FC = () => {
    return (
        <>
            <LogisticsSection
                data={FRUIT_DATA}
                title="FRUIT"
                namespaceKey="item"
                keepIndices={[0, 1, 2, 4]}
                id="fruit-section"
            />
            <LogisticsSection
                data={VEGGIE_DATA}
                title="VEGETALES"
                namespaceKey="itemV"
                keepIndices={[0, 2, 4, 6]}
            />
            <LogisticsSection
                data={GRAINS_DATA}
                title="GRANOS"
                namespaceKey="itemG"
                keepIndices={[0, 2, 3, 5]}
            />
            <LogisticsSection
                data={PROTEIN_DATA}
                title="PROTEINAS"
                namespaceKey="itemP"
                keepIndices={[0, 1, 3, 6]}
            />
            <LogisticsSection
                data={HAM_DATA}
                title="JAMONES"
                namespaceKey="itemH"
                keepIndices={[0, 2, 4, 6]}
            />
            <LogisticsSection
                data={DAIRY_DATA}
                title="LACTEOS"
                namespaceKey="itemD"
                keepIndices={[0, 2, 3, 6]}
            />
        </>
    );
};
